(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/high-limit-note.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/high-limit-note.js');
'use strict';

const formatCurrency = svs.utils.format.Currency;
const HighLimitNote = _ref => {
  let {
    dayLimit,
    monthLimit,
    weekLimit
  } = _ref;
  const highTreshold = 1000;
  const veryHighTreshold = 10000;
  const noteHigh = value => value > highTreshold && value < veryHighTreshold;
  const noteVeryHigh = value => value > veryHighTreshold - 1;
  const limitEconomicInspectionMsg = value => value > veryHighTreshold;
  const isHigh = noteHigh(dayLimit) || noteHigh(weekLimit) || noteHigh(monthLimit);
  const isVeryHigh = noteVeryHigh(dayLimit) || noteVeryHigh(weekLimit) || noteVeryHigh(monthLimit);
  const isEconomicInspectMsg = limitEconomicInspectionMsg(monthLimit);
  const monthLimitString = formatCurrency(monthLimit);
  if (isHigh || isVeryHigh || isEconomicInspectMsg) {
    return React.createElement("div", {
      className: "margin-bottom-4 align-center f-content"
    }, React.createElement("div", {
      className: "bg-grey-200 padding-1 u-border-radius-12"
    }, React.createElement("span", {
      className: "margin-bottom-0"
    }, "L\xE4gg m\xE4rke till att en gr\xE4ns p\xE5", isVeryHigh && " ".concat(monthLimitString, " kan anses vara mycket h\xF6g."), !isVeryHigh && isHigh && " ".concat(monthLimitString, " kan anses vara h\xF6g.")), isEconomicInspectMsg && React.createElement("div", null, "N\xE4r du s\xE4tter en gr\xE4ns \xF6ver 10 000 kr kan vi komma att pr\xF6va din ekonomiska f\xF6rm\xE5ga. Detta kan leda till att vi s\xE4tter gr\xE4nsen till l\xE4gre \xE4n du \xF6nskat.")));
  }
  return null;
};
svs.accountservicesReact.gameLimitDepositsForm.HighLimitNote = HighLimitNote;

 })(window);